import React from 'react';
import { Button, Tooltip } from 'antd';
import { BulbOutlined, BgColorsOutlined } from '@ant-design/icons';
import { useTheme } from '@/context/theme';
import { useDispatch, useSelector } from 'react-redux';
import { toggleTheme } from '@/redux/theme';

const ThemeToggle = () => {
    const { isDarkMode, toggleTheme: toggleContextTheme } = useTheme();
    const dispatch = useDispatch();

    const handleToggle = () => {
        dispatch(toggleTheme());
        toggleContextTheme();
    };

    return (
        <Tooltip title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
            <Button
                type="text"
                icon={isDarkMode ? <BulbOutlined /> : <BgColorsOutlined />}
                onClick={handleToggle}
                style={{
                    border: 'none',
                    background: 'transparent',
                }}
            />
        </Tooltip>
    );
};

export default ThemeToggle;
